import Container from '@/components/@base/container';
import Header from '@/components/header';
import Invoice from '@/components/invoice/invoice';
import Payment from '@/components/payment';
import WalletsSection from '@/components/wallets-section';
import VouchersSection from '@/components/vouchers-section';
import OrderSummary from '@/components/desktop/orderSummary';
import DesktopInvoice from '@/components/desktop/invoice';
import PaymentWithId from '@/components/payment-with-id';
import BiometricGate from '@/components/biometric-gate';

const Home = () => {
  return (
    <BiometricGate>
    <Container>
      <Container className={'mb-20 flex flex-col pb-[150px] lg:hidden'}>
        <Header showAds={true}/>
        <Invoice />
        <WalletsSection isBankCardMode={true}/>
        <VouchersSection />
        <WalletsSection />
        <PaymentWithId/>
        {/*=================*/}
        <Payment />
      </Container>

      <Container className='xl:mx-auto my-10 xl:max-w-[70%] lg:max-w-full lg:mx-10 rounded-xl p-10 shadow-[0_0_7px_0_#00000021] dark:shadow-[0_0_8px_0_#00000040] hidden lg:block'>
        <Header />
        <Container className='mt-10 grid grid-cols-12 gap-[50px]'>
          <Container className='col-span-7 mb-[100px]'>
            <WalletsSection isBankCardMode={true}/>
            <VouchersSection />
            <WalletsSection />
            <PaymentWithId/>
          </Container>
          <Container className='col-span-5'>
            <div className='sticky top-6'>
              <DesktopInvoice />
              <OrderSummary />
            </div>
          </Container>
        </Container>
      </Container>
    </Container>
    </BiometricGate>
  );
};

export default Home;
